<template>
  <b-field label="Registration Type" horizontal>
    <b-select v-model="value">
      <option v-for="choice in choices" :value="choice" :key="choice">{{ choice }}</option>
    </b-select>
  </b-field>
</template>

<script>
export default {
  name: 'frontend-registration-type',
  props: ['value'],
  data() {
    return {
      choices: ['basic', 'agent'],
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/components/Projects/Form/Frontend/RegistrationType.vue